import { request } from "../request";
import { checkListImageBase, InterceptPrefix, checkImageBase } from '../utils';

export const getAllLocs = (params) => {
    return request({
        method: 'post',
        url: '/locations/getallbyuser',
        params
    }).then(checkListImageBase)
}

export const getStocksStats = (params) => {
    return request({
        method: 'post',
        url: '/stocks/stats',
        params
    }).then((res) => {
        const { photoUrl, thumbnailUrl } = res.location || {};
        photoUrl && (res.location.photoUrl = checkImageBase(photoUrl))
        thumbnailUrl && (res.location.thumbnailUrl = checkImageBase(thumbnailUrl))
        return res;
    })
}

export const getLocStats = (params) => {
    return request({
        method: 'post',
        url: '/stocks/stats/location',
        params
    }).then((res) => {
        const { photoUrl, thumbnailUrl } = res.location || {};
        photoUrl && (res.location.photoUrl = checkImageBase(photoUrl))
        thumbnailUrl && (res.location.thumbnailUrl = checkImageBase(thumbnailUrl))
        return res;
    })
}

export const addLoc = (params) => {
    return request({
        method: 'post',
        url: '/locations/add',
        params: params
    })
}

export const editLoc = ({ id, nickname, address, photoUrl, thumbnailUrl, photoRemove, ...other }) => {
    return request({
        method: 'post',
        url: '/locations/edit',
        params: {
            ...other,
            id, nickname, address, photoRemove,
            photoUrl,
            thumbnailUrl
        }
    })
}
export const delLoc = ({ selectedLocation }) => {
    return request({
        method: 'post',
        url: '/locations/delete',
        params: { id: selectedLocation.id }
    })
}
